import { buildModelManager } from "../builder.js";
const DefaultPhiInventoryItemSelection = {
  __typename: true,
  id: true,
  cleanupApprovalId: true,
  createdAt: true,
  discoveredAt: true,
  fieldName: true,
  institution: true,
  modelName: true,
  recordId: true,
  riskLevel: true,
  summary: true,
  updatedAt: true,
  vaultObjectId: true
};
const modelApiIdentifier = "phiInventoryItem";
const pluralModelApiIdentifier = "phiInventoryItems";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPhiInventoryItemSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPhiInventoryItemSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPhiInventoryItemSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPhiInventoryItemSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPhiInventoryItemSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPhiInventoryItemSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPhiInventoryItemSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "phiInventoryItemGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const PhiInventoryItemManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultPhiInventoryItemSelection,
  operations
);
export {
  DefaultPhiInventoryItemSelection,
  PhiInventoryItemManager
};
//# sourceMappingURL=PhiInventoryItem.js.map
